import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import './ChooseOffer.css';
import {Button} from '../../components/Button';
import {openCheckout} from './Paddle';

export interface ChooseOfferProps {

}

export const ChooseOffer: FunctionComponent<ChooseOfferProps> = observer(() =>
    <section className="offer-section mb-8">
        {/*<h1 className="font-bold font-roboto-bold mb-2 text-3xl">Choose your subscription:</h1>*/}
        {/*<div className="offer-box blue-box lg:w-1/4 sm:w-1/2">
            <h2>Muscula Basic - Free</h2>
            <p className="leading-none">For one project or website or appliction</p>
            <Button className="btn-primary mt-3 md:mt-0"
                    onClick={() => openCheckout(637094)}>
                Subscribe
            </Button>
        </div>*/}
        <div className="offer-box purple-box mt-4 lg:w-3/4 sm:w-100">
            <h2>Upgrade to Muscula Business - 14$ monthly</h2>
            <p className="leading-none">
                Unlimited projects, applications and websites
            </p>
            <Button className="btn-primary mt-3 md:mt-0"
                    onClick={() => openCheckout(637093)}>
                Subscribe
            </Button>
        </div>
    </section>
);
